<template>


    <tq-card max-width="350px" width="100%" margin="12px" class="TQ_clickable">

        <div class="TQ_grid_col_1frAutoAuto">

            <!-- info -->
            <div>

                <!-- basic info-->
                <div class="TQ_grid_col_auto1fr TQ_grid_gap_4px">

                    <img :src="p_questEvent_c.qev_cm_getImageFile_c(p_systemLangCode_e).fi_url_s" class="TQ_width_100px" :class="co_rightToLeft_b ? 'lc_eventImage_rightToLeft' : 'lc_eventImage_leftToRight' "/>

                    <!-- text -->
                    <div class="TQ_textAlign_initial TQ_grid_verticalCenter">
                        <div class="TQ_text_20px TQ_text_bold TQ_margin_bottom_4px">{{p_questEvent_c.qev_name_byLangCode_s[co_questEvent_displayLangCode_e]}}</div>
                        <div>{{format_date_YYYY_MM_DD_hh_mm_fs(p_questEvent_c.qev_startingDate_t)}}</div>
                    </div>

                </div>
                <hr class="TQ_margin_0px">

                <!-- more info -->
                <div class="TQ_padding_4px TQ_textAlign_initial TQ_center" :class="p_ticketOwner_b ? 'TQ_grid_col_1fr1fr1fr' : 'TQ_grid_col_1fr1fr'">
                    <div>
                        <img class="TQ_width_20px TQ_margin_top_4px" :src="ass_img_clock" title="Quest Duration"/> <br>
                        {{format_duration_minutes(p_questEvent_c.qev_durationInMinutes_n,co_questEvent_displayLangCode_e)}}
                    </div>
                    <div >
                        <img class="TQ_width_20px TQ_margin_top_4px" :src="ass_img_playersGroup" title="Spots Left"/> <br>
                        <div class="TQ_direction_ltr"> {{obj_size_fn(p_questEventTicket_c.qt_playersJoinDate_byUserId_t)}} / {{p_questEventTicket_c.qt_spots_n}} </div>
                    </div>
                    <div v-if="p_ticketOwner_b">
                        <img class="TQ_width_20px TQ_margin_top_4px" :src="ass_img_profit_b" title="Cost"/> <br>
                        {{format_cost_s(p_questEventTicket_c.qt_cost_c)}}
                    </div>
                </div>
                <hr class="TQ_margin_0px">

                <!-- ticket short key-->
                <div class="TQ_margin_6px" @click.stop="m_copyShortTicketCode_f">
                    {{ass_string.twoWords_entryCode[p_systemLangCode_e]}}:
                    <span class="TQ_bg_gold TQ_padding_4px TQ_text_bold TQ_borderRadius">{{p_questEventTicket_c.qt_shortKeyId_s}}</span>
                    <div class="TQ_inline TQ_margin_4px"></div>
                    <img :src="ass_img_copyLink_b" class="TQ_width_16px"/>
                </div>

            </div>

            <!-- ticket dots -->
            <div :class="co_rightToLeft_b ?  'lc_statusLeft' : 'lc_statusRight'"></div>

            <!-- ticket status -->
            <div class="TQ_text_capitalize TQ_text_topToBottom TQ_text_20px">

                <!-- approved -->
                <div v-if="[enum_questTicketStatus.approved, enum_questTicketStatus.charged, enum_questTicketStatus.creatorRequestApproved].includes(p_questEventTicket_c.qt_status_e)">

                    <!-- join to quest -->
                    <div :class="co_rightToLeft_b ?  'TQ_borderRadius_left' : 'TQ_borderRadius_right'"
                         class="TQ_bg_green TQ_padding_4px">
                        {{ass_string.oneWord_ready[p_systemLangCode_e]}}
                    </div>

                    <!-- quest finish-->
                    <!--<div v-else-->
                         <!--:class="co_rightToLeft_b ?  'TQ_borderRadius_left' : 'TQ_borderRadius_right'"-->
                         <!--class="TQ_bg_red TQ_padding_4px">-->
                        <!--{{ass_string.twoWords_questFinish[p_systemLangCode_e]}}-->
                    <!--</div>-->
                </div>

                <!-- cancel-->
                <div v-else-if="[enum_questTicketStatus.canceled, enum_questTicketStatus.creatorRequestDecline].includes(p_questEventTicket_c.qt_status_e)"
                     :class="co_rightToLeft_b ?  'TQ_borderRadius_left' : 'TQ_borderRadius_right'"
                     class="TQ_bg_red TQ_padding_4px">
                    {{ass_string.oneWord_canceled[p_systemLangCode_e]}}
                </div>

                <!-- expired -->
                <div v-else-if="p_questEventTicket_c.qt_status_e === enum_questTicketStatus.expired"
                     :class="co_rightToLeft_b ?  'TQ_borderRadius_left' : 'TQ_borderRadius_right'"
                     class="TQ_bg_red TQ_padding_4px">
                    {{ass_string.twoWords_expired[p_systemLangCode_e]}}
                </div>

                <!-- waiting to approve  -->
                <div v-else-if="[enum_questTicketStatus.waitingToApprove, enum_questTicketStatus.creatorRequest].includes(p_questEventTicket_c.qt_status_e) "
                     :class="co_rightToLeft_b ?  'TQ_borderRadius_left' : 'TQ_borderRadius_right'"
                     class="TQ_bg_gold_w TQ_padding_4px">
                    {{ass_string.oneWord_waiting[p_systemLangCode_e]}}
                </div>

                <!-- join to start -->
                <div v-else-if="!p_questEvent_c.qev_startingDate_t"
                     :class="co_rightToLeft_b ?  'TQ_borderRadius_left' : 'TQ_borderRadius_right'"
                     class="TQ_bg_red TQ_padding_4px">
                    {{ass_string.sentence_joinToStartQuest[p_systemLangCode_e]}}
                </div>

            </div>

        </div>

    </tq-card>




</template>

<script>
    import {FB_QuestEvent} from "../../../../../functions/src/shareCode/Share_S_Classes";
    import {validator_enum_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {
        format_questType
    } from "../../../../../functions/src/shareCode/Share_S_Format";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqOnTopContainer from "../../../../components/basic/TqOnTopContainer";
    import {
        enum_costCurrency_n,
        enum_directions, enum_langCodes,
        enum_questTicketStatus
    } from "../../../../../functions/src/shareCode/Share_S_Enum";
    import {obj_size_fn} from "../../../../../functions/src/shareCode/Share_S_Obj";
    import {
        ass_img_clock, ass_img_copyLink_b,
        ass_img_playersGroup_b, ass_img_profit_b, ass_img_reviews_b,
        ass_img_type
    } from "../../../../assets/scripts/Ass_Files";
    import {
        format_cost_s,
        format_date_YYYY_MM_DD_hh_mm_fs,
        format_duration_minutes
    } from "../../../../../functions/src/shareCode/Share_S_Format";
    import {FB_QuestTicket} from "../../../../../functions/src/shareCode/Share_S_Classes";
    import TqCard from "../../../../components/basic/TqCard";
    import {
        helper_copyStringToClipboard,
        helper_getDirectionByLangCode_fe,
        helper_getDisplayLang_e
    } from "../../../../scripts/S_Helper";
    import {notification_notify} from "../../../../scripts/S_Notification";
    import Si_review from "../../../../components/a_smartIcons/si_review";

    export default {
        name: "c_Player_Tickets_List_Ticket",
        components: {Si_review, TqCard, TqOnTopContainer},
        props:{
            p_questEvent_c: {
                type:FB_QuestEvent,
                require:true
            },
            p_questEventTicket_c:{
                type:FB_QuestTicket,
                require:true
            },
            p_ticketOwner_b:{
                type:Boolean,
                require:true
            },
            p_systemLangCode_e:{
                type:String,
                require: true,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },

        },
        data(){
            return {
                // imports
                ass_string : ass_strings,
                enum_questTicketStatus:     enum_questTicketStatus,
                enum_directions:     enum_directions,
                ass_img_clock : ass_img_clock,
                ass_img_type : ass_img_type,
                ass_img_playersGroup : ass_img_playersGroup_b,
                ass_img_profit_b : ass_img_profit_b,
                ass_img_copyLink_b : ass_img_copyLink_b,
                ass_img_reviews_b : ass_img_reviews_b,

                obj_size_fn                     : obj_size_fn,
                format_date_YYYY_MM_DD_hh_mm_fs : format_date_YYYY_MM_DD_hh_mm_fs,
                format_duration_minutes         : format_duration_minutes,
                format_questType                : format_questType,
                format_cost_s                   : format_cost_s,
                helper_getDirectionByLangCode_fe: helper_getDirectionByLangCode_fe,
            }
        },
        computed:{
            co_questEvent_displayLangCode_e(){
                return helper_getDisplayLang_e(this.p_systemLangCode_e, this.p_questEvent_c.qev_supportedLangCodes_ae, this.p_questEvent_c.qev_defaultLang_e)
            },
            co_rightToLeft_b(){
                return helper_getDirectionByLangCode_fe(this.p_systemLangCode_e) === enum_directions.rtl
            },

        },
        methods : {
            m_copyShortTicketCode_f(){
                helper_copyStringToClipboard(this.p_questEventTicket_c.qt_shortKeyId_s)
                notification_notify(ass_strings.threeWords_entryCodeCopied)
            }
        }



    }
</script>

<style scoped lang="scss">


    .infoSection{
        display:inline-block;
        margin: 8px 0;
        min-width: 50px;
        width: 25%;
        img {
            width: 30px;
            margin-bottom: 4px;
        }
    }


    .topImg{
        border-bottom: 1px solid black;
        border-radius: 5px 5px 0px 0px;
    }

    .approve{
        background: green;
        padding: 8px;
        color:white;
        border-radius: 0px 0px 5px 5px;
    }

    .lc_eventImage_rightToLeft{
        border-radius: 0 5px 0 0;
    }

    .lc_eventImage_leftToRight{
        border-radius: 5px 0 0 0;
    }

    .lc_statusLeft{
        border-right:6px dotted white;
        margin-left: -3px;
        z-index: 1;

    }


    .lc_statusRight{
        border-left:6px dotted white;
        margin-right: -3px;
        z-index: 1;

    }





</style>